export default {

    // Persistent state.
    apiKey: localStorage.getItem('api_key'), // API key.
    inviteToken: localStorage.getItem('invite_token'), // Member invite token to join a space.
    checklists: JSON.parse(localStorage.getItem('checklists')) || [], // Dismissed checklists.
    sidebarState: localStorage.getItem('sidebar_state') || 'expanded', // Hide or show sidebar.
    locationId: localStorage.getItem('location_id') === 'null' ? null : localStorage.getItem('location_id'), // Selected location ID.
    lang: localStorage.getItem('lang') || 'en', // Selected language.
    refFirst: localStorage.getItem('ref_first') || null, // First referral click.
    refFirstAt: localStorage.getItem('ref_first_at') ? parseInt(localStorage.getItem('ref_first_at'), 10) : null, // First referral click timestamp.
    refLast: localStorage.getItem('ref_last') || null, // Most recent referral click.
    refLastAt: localStorage.getItem('ref_last_at') ? parseInt(localStorage.getItem('ref_last_at'), 10) : null, // Most recent referral click timestamp.

    // Temporary state.
    app: null, // Data the app needs to work.
    user: null, // Authenticated user.
    agency: null, // Selected agency.
    project: null, // Selected project.
    alerts: [], // Global alerts.
    operations: [], // App-wide in-progress / success banners.
    loading: false, // Global loading indicator.
    modal: null, // Modal to show.
    modalTab: null, // Tab of modal to show.
    dropdown: null, // Dropdown to show.
    expandableSection: null, // Currently expanded section title (accordion).
    task: null, // Selected task in checklist.
    consent: null, // Cookie consent categories.
    showCookieBanner: false, // Whether the cookie consent banner should be visible.

}
